import React from 'react';
import styled from 'styled-components';

const HeaderContainer = styled.header`
    background-color: rgb(36, 23, 60);
    padding: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

const Logo = styled.h1`
    font-size: 24px;
    color: #FFF;
`;

const Nav = styled.nav`
    ul {
        list-style: none;
        display: flex;
        gap: 20px;

        li {
            a {
                text-decoration: none;
                color: #FFF;
                font-weight: bold;

                &:hover {
                    color: #ff6600;
                }
            }
        }
    }
`;

const Header: React.FC = () => {
    return (
        <HeaderContainer>
            <Logo>Investment calculator</Logo>
            <Nav>
                <ul>
                    <li>
                        <a href="/home">Home</a>
                    </li>
                    <li>
                        <a href="/about">About</a>
                    </li>
                    <li>
                        <a href="/services">Services</a>
                    </li>
                    <li>
                        <a href="/contact">Contact</a>
                    </li>
                    <li>
                        <a href="/logout">Log out</a>
                    </li>
                </ul>
            </Nav>
        </HeaderContainer>
    );
};

export default Header;
